import { colors } from '#base/js/variables.style'
import { createUseStyles } from 'react-jss'

export const style = {
  placeholderContainer: {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    border: `1px dashed ${colors.brandAccent}`,
    borderRadius: '5px',
    padding: 20
  },
  forestIcon: {
    height: '40px',
    paddingTop: 5
  },
  sunburstIcon: {
    height: '45px'
  },
  displayName: {
    marginLeft: 15,
    fontSize: 20
  },
  editButton: {
    flex: 1,
    textAlign: 'right'
  }
}

export const useStyles = createUseStyles(style)
